import { Dialog, DialogTitle, DialogActions, DialogContent, Typography, Button } from "@mui/material";
import { ChangeAccountStatusDialogType } from "../actions/data";
import { DialogContentContainer, DialogContentItem } from "./styles";

const ChangeAccountStatusDialog = (props: ChangeAccountStatusDialogType) => {

  const {open, onClose, account, onChangeAction} = props;

  const title = account?.activated ? 'DEACTIVATE ACCOUNT' : 'ACTIVATE ACCOUNT';
  const warningMessage = account?.activated ? 'YOU ARE ABOUT TO DEACTIVATE THIS ACCOUNT.' : 'YOU ARE ABOUT TO ACTIVATE THIS ACCOUNT.'
  
  return <Dialog open={open} onClose={onClose}>
    <DialogTitle>{title}</DialogTitle>
    <DialogContent>
      <DialogContentContainer>
        <DialogContentItem>
          <Typography>
            {warningMessage}
          </Typography>
        </DialogContentItem>
        <DialogContentItem>
          <Typography>
            Account: {account?.id}
          </Typography>
          <Typography>
            Company: {account?.companyName}
          </Typography>
        </DialogContentItem>
      </DialogContentContainer>
    </DialogContent>
    <DialogActions>
      <Button variant='contained' color='primary' onClick={() => onChangeAction(account)}>Save Changes</Button>
      <Button variant="outlined" onClick={onClose}>Close</Button>
    </DialogActions>
  </Dialog>
}

export default ChangeAccountStatusDialog;